// Constants
export const FALLBACK_LANGUAGE = "en_GB";
export const COMPONENT_TYPE = "webclient";

// URL
export const LANGUAGE_TRANSLATION = `/api/public/language/v2/components/evio/webclient/`;
export const ALLOWED_LANGUAGES = `/api/public/language/v2/languagesAllowed`;
export const CHANGE_ACCOUNT_LANGUAGE = `/api/private/user/preferences/language?language=`;
